"use client";

import { Job } from "@/lib/types";
import ReactMarkdown from "react-markdown";

import { ArrowRight, X } from "lucide-react";
import { useRef, useState } from "react";
import posthog from "posthog-js";

export default function JobsList({ records }: { records: Job[] }) {
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);

  const dialogRef = useRef<HTMLDialogElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="scrollbar-thin scrollbar-thumb-primary flex flex-col divide-y divide-gray-100 md:pr-4 lg:h-80 lg:overflow-y-scroll">
      {records?.map((job: Job) => {
        return (
          <div key={job.id} className="flex flex-col gap-2 py-2.5">
            <h3>{job.fields.Job}</h3>
            <div
              className="text-primary flex cursor-pointer items-center justify-center gap-2 self-end text-xl font-semibold hover:underline"
              onClick={() => {
                setSelectedJob(job);
                dialogRef.current?.showModal();
                if (!contentRef.current) return;
                contentRef.current.scrollTop = 0;
                posthog.capture("job_listing_opened", {
                  job_title: job.fields.Job,
                });
              }}
            >
              Read more <ArrowRight size={16} />
            </div>
          </div>
        );
      })}
      <dialog className="fixed inset-0 z-50" ref={dialogRef}>
        <div
          className="fixed inset-0 bg-black/50"
          onClick={() => dialogRef.current?.close()}
        />
        <div className="fixed inset-x-2 inset-y-10 mx-auto flex justify-center overflow-hidden rounded-3xl bg-white px-2 md:inset-x-10 lg:w-200">
          <button
            className="absolute top-4 right-4 cursor-pointer"
            onClick={() => dialogRef.current?.close()}
          >
            <span className="sr-only">Close</span>
            <span aria-hidden="true">
              <X />
            </span>
          </button>
          <div
            ref={contentRef}
            className="prose md:prose-p:!text-lg prose-li:text-base md:prose-li:text-lg prose-h1:text-primary prose-h1:text-center scrollbar-thin scrollbar-thumb-gray-200 my-10 max-w-2xl overflow-y-auto overscroll-none bg-white px-6"
          >
            <ReactMarkdown>
              {selectedJob?.fields["Job Description"]}
            </ReactMarkdown>
          </div>
        </div>
      </dialog>
    </div>
  );
}
